import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Process', href: '#process' },
    { label: 'About', href: '#why-us' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#" className="flex flex-col leading-none cursor-pointer">
          <span
            className={`font-bold text-xl tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-stone-900' : 'text-white'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Fletcher &amp; Cooley
          </span>
          <span
            className={`text-xs tracking-widest uppercase transition-colors duration-300 ${
              scrolled ? 'text-amber-700' : 'text-amber-300'
            }`}
          >
            General Contractors
          </span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 hover:text-amber-600 cursor-pointer ${
                scrolled ? 'text-stone-700' : 'text-white/90'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:6783948805"
            className={`text-sm font-semibold tracking-wide transition-colors duration-300 cursor-pointer ${
              scrolled ? 'text-stone-700' : 'text-white/90'
            }`}
          >
            (678) 394-8805
          </a>
          <a
            href="#contact"
            className="whitespace-nowrap bg-amber-700 hover:bg-amber-800 text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-all duration-300 cursor-pointer"
          >
            Request Consultation
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i
            className={`text-2xl transition-colors duration-300 ${
              scrolled ? 'text-stone-900' : 'text-white'
            } ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}
          />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-stone-100 px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-stone-800 font-medium text-base cursor-pointer hover:text-amber-700 transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:6783948805"
            className="text-amber-700 font-bold text-lg cursor-pointer"
          >
            (678) 394-8805
          </a>
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="whitespace-nowrap bg-amber-700 text-white text-sm font-semibold px-6 py-3 rounded-full text-center cursor-pointer"
          >
            Request Consultation
          </a>
        </div>
      )}
    </header>
  );
}
